export default "__VITE_ASSET__CUQTmmWr__"